<template>
    <div class="container-fluid m-0 p-0">
        <div class="row text-left bg-light border-bottom py-3 d-flex justify-content-between">
            <div class="col-auto">
                <h5 class="mb-0 font-weight-bold">Generate IMO Crew List</h5>
            </div>
            <div class="col-auto">
                <button class="btn btn-xs btn-outline-secondary px-2 mr-1" title="Go to Previous Page"
                        @click="goBack"
                >
                    <span class="fas fa-backward"></span>
                    Go Back
                </button>
            </div>
        </div>

        <div class="row py-2">
            <div class="col-10 text-left">
                <div class="form-inline d-flex justify-content-center w-100">
                    <div class="form-group py-1 mx-3">
                        <span class="small font-weight-bold mr-2">Select Report Type: </span>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" id="arrival" :value="true"
                                   v-model="params.arrival"
                            >
                            <label class="form-check-label form-control-xs" for="arrival">Arrival</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" id="departure" :value="false"
                                   v-model="params.arrival"
                            >
                            <label class="form-check-label form-control-xs" for="departure">Departure</label>
                        </div>
                    </div>
                    <div class="form-group py-1 mx-3">
                        <label for="vessels" class="form-control-xs font-weight-bold" >Select Vessel: </label>
                        <select class="form-control form-control-xs mx-2" id="vessels" v-model="params.vesselId">
                            <option :value="undefined">---Select Vessel---</option>
                            <option v-for="vessel in vesselKeys" :key="vessel.id" :value="vessel.id">
                                {{vessel.name}}
                            </option>
                        </select>
                    </div>
                    <div class="form-group py-1 mx-3">
                        <label for="arrivalDepartureDate" class="form-control-xs font-weight-bold"
                               style="width: 112px;"
                        >
                            Date of {{ reportType }}:
                        </label>
                        <input type="date" id="arrivalDepartureDate" class="form-control form-control-xs mx-2"
                               v-model="params.arrivalDate"
                        >
                    </div>
                    <div class="form-group py-1 mx-3">
                        <label for="ports" class="form-control-xs font-weight-bold" >Port From: </label>
                        <select class="form-control form-control-xs mx-2" id="ports" style="width: 291px;"
                                v-model="params.portFrom"
                        >
                            <option :value="undefined">---Select Port---</option>
                            <option v-for="port in portKeys" :key="port.id" :value="port.id">
                                {{port.name}}
                            </option>
                        </select>
                    </div>
                    <div class="form-group py-1 mx-3">
                        <label for="portsFrom" class="form-control-xs font-weight-bold" >Port To: </label>
                        <select class="form-control form-control-xs mx-2" id="portsFrom" style="width: 291px;"
                                v-model="params.portTo"
                        >
                            <option :value="undefined">---Select Port---</option>
                            <option v-for="port in portKeys" :key="port.id" :value="port.id">
                                {{port.name}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-2 text-center d-flex justify-content-end align-items-center">
                <button class="btn btn-primary btn-xs font-weight-bolder p-1 d-flex align-items-center" @click="testOpenPDF"
                        :disabled="!params.vesselId"
                        :title="params.vesselId ? '' : 'Please Select Vessel First'"
                >
                    <i class="fas fa-file-pdf fa-2x mx-1"></i>
                    Generate Report
                </button>
            </div>

            <div class="col col-12">
                <table class="table table-hover table-bordered table-template-1 my-2 text-small sticky-header">
                    <thead>
                    <tr>
                        <th>No</th>
                        <th>Family name, given names</th>
                        <th>Rank or rating</th>
                        <th>Nationality</th>
                        <th>Date and place of birth</th>
                        <th rowspan="2">
                            <p class="header-title tx-center mb-0">Passport Number and <br />Expiry Date</p>
                        </th>

                        <th rowspan="2">
                            <p class="header-title tx-center mb-0">Seaman's Book and <br /> Expiry Date</p>
                        </th>
                        <th rowspan="2">
                            <p class="header-title tx-center mb-0">Embarkation Date <br/> and Place</p>
                        </th>
                    </tr>
                    </thead>

                    <tbody class="text-small">


                    <tr v-if="isLoading">
                        <td colspan="100%">
                            <app-loading></app-loading>
                        </td>
                    </tr>

                    <template v-else>
                        <tr v-for="(crew, index) in imoCrewList" :key="crew.id">
                            <td>{{ index + 1 }}</td>
                            <td :title="isSystemAdmin ? crew.id : ''">
                                <router-link :to="{name:'CrewActivity',params:{id:crew.id}}" target="_blank"
                                             v-if="crew.fullName" class="mb-0">{{ crew.fullName }}
                                </router-link>
                                <p class="text-danger font-weight-bolder mb-0" v-else>NO DATA</p>
                            </td>
                            <td>
                                <p v-if="crew.rank" class="mb-0">{{ crew.rank }}</p>
                                <p class="text-danger font-weight-bolder mb-0" v-else>NO DATA</p>
                            </td>
                            <td>
                                <p v-if="crew.nationality" class="mb-0">{{ crew.nationality }}</p>
                                <p class="text-danger font-weight-bolder mb-0" v-else>NO DATA</p>
                            </td>
                            <td class="text-center">
                                <p v-if="crew.birthDate" class="mb-0">{{ crew.birthDate }}</p>
                                <p class="text-danger font-weight-bolder mb-0" v-else>NO DATA</p>

                                <p v-if="crew.birthPlace" class="mb-0">{{ crew.birthPlace }}</p>
                                <p class="text-danger font-weight-bolder mb-0" v-else>NO DATA</p>
                            </td>
                            <td class="text-center">
                                <p class="mb-0 font-weight-bold">PASSPORT:</p>
                                <p v-if="crew.passportNumber" class="mb-0">{{ crew.passportNumber }}</p>
                                <p v-else class="text-danger font-weight-bolder mb-0">NO DATA</p>

                                <p v-if="crew.passportExpiryDate" :class="comparedDate(crew.passportExpiryDate)"
                                   class="mb-0">{{ crew.passportExpiryDate }}</p>
                                <p v-else class="text-danger font-weight-bolder mb-0">NO DATA</p>
                            </td>
                            <td class="text-center">
                                <p class="mb-0 font-weight-bold">SEAMANS BOOK:</p>
                                <p v-if="crew.seamansBookNumber" class="mb-0">{{ crew.seamansBookNumber }}</p>
                                <p v-else class="text-danger font-weight-bolder mb-0">NO DATA</p>

                                <p v-if="crew.seamansBookExpiryDate" class="mb-0">{{ crew.seamansBookExpiryDate }}</p>
                                <p v-else class="text-danger font-weight-bolder mb-0">NO DATA</p>
                            </td>
                            <td class="text-center">
                              <p v-if="crew.embarkationDate" class="mb-0">
                                {{
                                  crew.previousCrewActivity.hasOwnProperty('start_date') ?
                                      crew.previousCrewActivity.start_date : crew.embarkationDate
                                }}
                              </p>
                              <p v-else class="text-danger font-weight-bolder mb-0">NO DATA</p>

                              <p v-if="crew.embarkationPlace" class="mb-0">
                                {{
                                  crew.previousCrewActivity.hasOwnProperty('start_port') ?
                                      crew.previousCrewActivity.start_port : crew.embarkationPlace
                                }}
                              </p>
                              <p v-else class="text-danger font-weight-bolder mb-0">NO DATA</p>
                            </td>
                        </tr>
                    </template>

                    </tbody>

                </table>
            </div>

        </div>


  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import { vueAppMixin } from "@/mixins/vueAppMixin";
import { dataMixin } from "@/mixins/dataMixin";
import { gateMixin } from "@/mixins/gateMixin";

import { ReportService } from "@/services/ReportService";

import AppLoading from "@/components/elements/AppLoading";

export default {
    name: 'GenerateIMOCrewList',


    mixins: [ vueAppMixin, dataMixin, gateMixin ],

    components: { AppLoading },

    data () {
        return {
            SERVER_API_URL: 'http://krbs_api.test/',
            params: {
                arrival: true,
                vesselId: undefined,
                arrivalDate: '',
                portFrom: undefined,
                portTo: undefined,
            },
            imoReportDetailsNeeded: {
                reportType: '',
                ship: '',
                portArrival: '',
                portFromArrival: '',
                arrivalDate: '',
            },

        }
    },
    methods: {

        ...mapActions([
            'getVesselKeys',
            'getPortKeys',
            'clearImoCrewList',
            'getImoCrewList',
            'setLoading'
        ]),

        testOpenPDF(){
            let params = this.params;
            params['vessel'] = this.vesselKeys.find(vesselKey => vesselKey.id === this.params.vesselId);
            ReportService.generateImoFile(params);
        },

      comparedDate ( expiryDate ) {
        let date1 = new Date(Date.parse(expiryDate));
        let date2 = new Date();

        if(date1 <= date2.setDate(date2.getDate())) {
          return 'text-danger'
          // return 'expired: '+date2
        } else if (date1 <  date2.setDate(date2.getDate() + 182)) {
          return 'text-warning'
          // return '6 mos: '+date2
        } else if(date1 < date2.setDate(date2.getDate() + 183)){
          return 'text-primary'
          // return '12 mos: '+date2
        } else {
          return 'text-black'
        }

      }
    },

    computed: {
        ...mapGetters([
            'vesselKeys',
            'portKeys',
            'imoCrewList'
        ]),

        reportType() {
            return this.params.arrival ? 'Arrival' : 'Departure'
        },
    },

    created() {
        this.getVesselKeys();
        this.getPortKeys();
        this.setLoading(false);
    },

    watch: {
        'params.vesselId'(newValue) {
          if (newValue === undefined) {
            this.clearImoCrewList()
            return
          }

          this.getImoCrewList(this.params);
        },
    }
};
</script>

<style scoped>

</style>
